export class Terminator {
    service: any = '';
    identity: any = '';
    router: any = '';
    binding: string = '';
    precedence: string = '';
    address: string = '';
    cost: number = 0;
    identitySecret: string = '';
};